'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgSun = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 24 24",
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M17.5 14.35c-.6 1.45-1.75 2.6-3.2 3.2-1.49.63-3.16.63-4.65 0-1.45-.6-2.6-1.75-3.2-3.2a5.956 5.956 0 0 1 0-4.65c.6-1.45 1.75-2.6 3.2-3.2 1.49-.63 3.16-.63 4.65 0 1.45.6 2.6 1.75 3.2 3.2.63 1.49.63 3.16 0 4.65zm3.35.56c.05-.09.05-.21 0-.3l-1.87-2.58 1.87-2.58c.05-.09.05-.21 0-.3a.316.316 0 0 0-.21-.21l-3-1V4.75c0-.11-.05-.21-.14-.27a.319.319 0 0 0-.3 0l-3 1-1.95-2.65a.363.363 0 0 0-.51-.03l-.03.03-1.87 2.58-3-1a.319.319 0 0 0-.3 0c-.09.06-.14.16-.14.27v3.25l-3 1c-.1.03-.18.11-.21.21-.05.09-.05.21 0 .3l1.79 2.59-1.83 2.58c-.05.09-.05.21 0 .3.03.1.11.18.21.21l3 1v3.19c0 .11.05.21.14.27.09.05.21.05.3 0l3-1 1.87 2.58c.11.15.33.18.48.06.02-.02.05-.04.06-.06l1.87-2.58 3 1c.09.05.21.05.3 0 .09-.06.14-.16.14-.27v-3.19l3-1c.1-.03.18-.11.21-.21h.12z",
  vectorEffect: "non-scaling-stroke",
  fill: "currentColor"
})));

exports["default"] = SvgSun;
